import * as Popover from '@radix-ui/react-popover';
import type { ReactNode } from 'react';
import { useCallback, useState } from 'react';

interface NMRiumTooltipProps {
  children: ReactNode;
  content: ReactNode;
  delay?: number;
}

export function NMRiumTooltip(props: NMRiumTooltipProps) {
  const { children, content, delay } = props;
  const [isVisible, setIsVisible] = useState(false);

  const handleOpenWithoutDelay = useCallback(() => {
    setIsVisible(true);
  }, []);

  const handleOpen = useCallback(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  const handleClose = useCallback(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <Popover.Root open={isVisible}>
      <Popover.Trigger
        asChild
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
        onPointerDown={handleOpenWithoutDelay}
      >
        {children}
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          hideWhenDetached
          className="z-100 rounded-md px-2 py-1 text-xs bg-neutral-900 text-white max-w-xs sm:max-w-full"
        >
          {content}
          <Popover.Arrow className="fill-neutral-900" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
